var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"max-width":"100%","height":"100vh","width":"auto\\9"},attrs:{"src":"/underconstruction.jpg","alt":"Construction Page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }